import React from 'react';
import { Grid, Stack, Box } from '@mui/material';
import PoolStatusChip from './PoolStatusChip';
import MatchCompletedTimestamp from './MatchCompletedTimestamp';
import PoolsTitleBarActions from './PoolsTitleBarActions';
import RoundsDisplay from './RoundsDisplay';

const StatusOrRoundsSection = ({ pool, isAdmin }) => {
    if (pool.rounds?.length > 0) {
        return (
            <>
                <Grid item md={2} sm={2} xs={2} mr={-5} sx={{ minWidth: '98px' }}>
                    <PoolStatusChip pool={pool} />
                </Grid>
                <Grid container md={6} sm={0} xs={0} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}>
                    <RoundsDisplay rounds={pool.rounds} />
                </Grid>
                <Grid container sm={12} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }} mt={2}>
                    <RoundsDisplay rounds={pool.rounds} />
                </Grid>
            </>
        );
    }
    return (
        <Grid item sm={2} xs={6} sx={{ minWidth: '98px' }}>
            <Stack direction="row" spacing={1}>
                <PoolStatusChip pool={pool} />
                <MatchCompletedTimestamp pool={pool} />
                {isAdmin && (
                    <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
                        <PoolsTitleBarActions pool={pool} />
                    </Box>
                )}
            </Stack>
        </Grid>
    );
};

export default StatusOrRoundsSection;
